// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1RvYR","colCheckbox":"styles_colCheckbox__28Uka"};